<div class="web-view" fxLayout="column">

    <div class="web" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>
        <div class="navbar-div">
            <app-web-navbar></app-web-navbar>
        </div>
    </div>

    <div class="mobile" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>

        <div class="mobile-navbar">
            <app-sidebar></app-sidebar>
        </div>

        <div class="navbar-div">
            <app-web-navbar></app-web-navbar>
        </div>

    </div>

    <div class="main-div" fxLayout="column wrap">

        <div class="div1 red">

            <div class="banner-div" fxLayout="row wrap" fxLayout.xs="column">

                <!-- <div class="text" fxFlex="30" fxFlex.xs="100" fxHide.xs>

                    <span>{{gsPage.bannerText}}</span>

                </div> -->

                <div class="image-div" fxFlex="70" fxFlex.xs="100">
                    <img src="{{gsPage.bannerImage}}" alt="">
                </div>

            </div>

            <div class="headings" fxLayout="row wrap">

                <p class="title" [innerHTML]="gsPage.title"></p>
                <p class="description desc-width" [innerHTML]="gsPage.description"></p>

            </div>

            <div fxLayout="row wrap" class="buttons-div" fxLayoutGap="50px" fxHide.xs fxHide.sm fxHide.lt-md fxShow.md>

                <button (click)="scroll(step1)">HOST A GROUP SHARE</button>

                <button (click)="scroll(step2)">ATTEND A GROUP SHARE</button>

                <a href="/cinejoy/premiere/lineup" target="_blank">
                    <button>BUY TICKETS</button>
                </a>

            </div>

            <!-- <div class="buttons-div" fxLayout="row" fxLayoutGap="10px" fxHide.xs fxHide.sm fxHide.lt-md fxShow.md>

                <button (click)="scroll(step1)">HOST A GROUP SHARE</button>
                <div class="white-line"></div>
                <button (click)="scroll(step2)">ATTEND A GROUP SHARE</button>
                <div class="white-line"></div>
                <a href="/cinejoy/premiere/lineup" target="_blank">
                    <button>BUY TICKETS</button>
                </a>

            </div> -->

            <div class="buttons-div-mob" fxLayout="column" fxHide.lg fxHide.md fxHide.lt fxShow.lt-md fxShow.xs
                fxHide.gt-lg>

                <div class="buttons-div-black" fxLayout="column" fxLayoutGap="10px">
                    <button (click)="scroll(step1)">HOST A GROUP SHARE</button>

                    <button (click)="scroll(step2)">ATTEND A GROUP SHARE</button>

                    <button (click)="navigate()">BUY TICKETS</button>

                </div>

            </div>

        </div>


        <div class="div2 black">

            <div class="headings" #step1>

                <p style="margin-top: 2%;" class="title" [innerHTML]="gsPage.step1Heading"></p>
                <p style="text-align: center !important;" class="description" [innerHTML]="gsPage.step1SubHeading"></p>

            </div>

            <div class="steps" fxLayout="row wrap" fxLayout.xs="column" style="margin: 2vw;">

                <div class="step-main" *ngFor="let item of gsPage.step1Arrays" fxLayout="column" fxFlex="35">
                    <div class="step-image-div" fxLayout="column">
                        <img src="{{item.image}}" alt="">
                    </div>
                    <div class="step-div" fxLayout="column">
                        <p class="step-no">STEP {{item.sequence}}</p>
                        <p class="step-desc" [innerHTML]="item.description"></p>
                    </div>
                </div>

            </div>

        </div>

        <div class="div3 black">

            <div class="headings" #step2>

                <p class="title" [innerHTML]="gsPage.step2Heading"></p>
                <p style="text-align: center !important;" class="description" [innerHTML]="gsPage.step2SubHeading"></p>

            </div>

            <div class="steps" fxLayout="row wrap" fxLayout.xs="column" style="margin: 2vw;">
                <div class="step-main" *ngFor="let item of gsPage.step2Arrays" fxLayout="column" fxFlex="35">
                    <div class="step-image-div" fxLayout="column">
                        <img src="{{item.image}}" alt="">
                    </div>
                    <div class="step-div" fxLayout="column">
                        <p class="step-no">STEP {{item.sequence}}</p>
                        <p class="step-desc" [innerHTML]="item.description"></p>
                    </div>
                </div>

            </div>

        </div>

        <hr>

    </div>


    <div class="footer-div" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>

    <div class="footer-div" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>

</div>